import { api, API_URL } from "../config/apiConfig";
import { handleUnauthorizedOrForbidden } from "../config/varConfig";


export const getAstrologerSignupRequests = async (params = {}) => {
  try {
    const response = await api.get(
      `${API_URL}/astrologers/getSignupRequests`,
      {
        params: params,
      }
    );
    return response.data;
  } catch (error) {
    handleUnauthorizedOrForbidden(error);
    throw error;
  }
};


export const approveAstrologerSignup = async (payload) => {
  try {
    const response = await api.put(
      `${API_URL}/astrologers/approveAstrologerSignup`,
      payload
    );
    return response.data;
  } catch (error) {
    handleUnauthorizedOrForbidden(error);
    throw error;
  }
};


